class Storehouse {
    serialNumber;
    deviceName;
    creator;
    datepublish;
    password;
    id;
    pin;


    constructor(serialNumber,deviceName,creator,datepublish,password,id,pin){
        this.serialNumber=serialNumber;
        this.deviceName=deviceName;
        this.creator=creator;
        this.datepublish=datepublish;
        this.password=password;
        this.id=id;
        this.pin=pin;
    }
    getId(){
        return this.id;
    }

}
export {Storehouse}